import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MessageService } from '../../../../../../shared/services/helpers/message-service/message.service';
import { ShootProofDataProvider } from '../../../../../../shared/services/integrations/shootProof/shootProof.data.service';
import { InvoicesDataProvider } from '../../../../../../shared/services/invoice/invoices-data-service/invoices.data.service';
import { Subject } from 'rxjs/Subject';

@Component({
	selector: 'shootproof-view-block',
	template: require('./shootProof-view-block.component.html'),
	styles: [require('./shootProof-view-block.component.scss')]
})
export class ShootProofViewBlockComponent implements OnInit {
	@Input('job') job: any;
	shootProofGalleries: Array<any> = [];
	galleryIdForDelete: number;
	shootProofBrands: Array<any> = [];
	jobId: number;
	availableActionsForGallery = null;
	mainShootDate: string;
	jobName: string;
	actions: Array<string>;
	state: string;

	constructor(
		private shootProofDataService: ShootProofDataProvider,
		private messageService: MessageService
	) {}

	ngOnInit() {
		this.setVariables();
		this.getGalleries();
	}

	getGalleries(): void {
		this.shootProofDataService
			.getJobGalleriesV1(this.jobId)
			.subscribe(
				data => this.successGetShootProofGalleries(data),
				error => this.messageService.showDefaultErrorMessage(error)
			);
	}

	private successGetShootProofGalleries(data) {
		if (data.data.shootProofGalleryLayout !== null) {
			const { avalibleActions, galleries } = data.data.shootProofGalleryLayout;
			this.actions = avalibleActions.reverse();
			this.shootProofGalleries = galleries;
		} else {
			this.actions = [];
			this.shootProofGalleries = [];
		}

		this.state = data.data.state;
	}

	showDeleteShootProofModal(gallery): void {
		this.availableActionsForGallery = gallery.availableActions;
		this.galleryIdForDelete = gallery.id;
		$('#deleteShootProofGalleryModal').modal('show');
	}

	showAddShootProofGalleryModal(): void {
		$('#addShootProofGalleryModal').modal('show');
	}

	getShootProofBrands(shootProofBrands): void {
		this.shootProofBrands = shootProofBrands;
	}

	private setVariables(): void {
		const { id, name, finishDate } = this.job;

		this.jobId = id;
		this.jobName = name;
		this.mainShootDate = finishDate;
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./web/modern/components/integrations/shootProof/shootProof-view-block/shootProof-view-block.component.ts